import { render, staticRenderFns } from "./cbsz.vue?vue&type=template&id=3d0cfb8f&scoped=true&"
import script from "./cbsz.vue?vue&type=script&lang=js&"
export * from "./cbsz.vue?vue&type=script&lang=js&"
import style0 from "./cbsz.vue?vue&type=style&index=0&id=3d0cfb8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cfb8f",
  null
  
)

export default component.exports